import { render, staticRenderFns } from "./Zakat.vue?vue&type=template&id=98aed01e"
import script from "./Zakat.vue?vue&type=script&lang=js"
export * from "./Zakat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports